import React, { Component } from 'react';
import DatePicker from 'react-datepicker';

const isMobile = require('ismobilejs');

class TabelaPeriodos extends Component {

    header = [
        {
            awesomeicon: "far fa-calendar-alt",
            title: "Período"
        }, {
            awesomeicon: "far fa-calendar-alt",
            title: "Data de início e fim"
        }
    ]

    componentDidMount() {
        if (this.props.editable) {
            this.header.push({
                awesomeicon: "fas fa-times",
                title: "Remover"
            })
        }
    }

    getStartMinDate(periods, index) {
        if (index > 0) {
            let lstDt = new Date(periods[index - 1].dtEndPeriod)
            lstDt.setDate(lstDt.getDate() + 1)
            return lstDt
        }
    }

    getStartMaxDate(periods, index) {
        return new Date(periods[index].dtEndPeriod)
    }

    getEndMinDate(periods, index) {
        return new Date(periods[index].dtStartPeriod)
    }

    getEndMaxDate(periods, index) {
        if (index < periods.length - 1) {
            let lstDt = new Date(periods[index + 1].dtStartPeriod)
            lstDt.setDate(lstDt.getDate() - 1)
            return lstDt
        }
    }

    render() {
        return (
            <div className={" " + this.props.className}>

                {this.props.periodos.map((item, index) =>
                    <div key={`config-periodo-item-${index}`} className="edb-row-cell edb-margin-top">
                        <div id={'titu-ano-' + item.txGrade}>
                            <h6>{item.txGrade}º ano</h6>
                        </div>
                        <table className="edb-table edb-round-large edb-bordered adap-white edb-striped ">
                            <thead className="edb-hide-small">
                                <tr id="table-header">
                                    {this.header.map((item, index) =>
                                        <th width={item.largura} key={index}>
                                            <div style={{ display: 'table-row' }}>
                                                {item.awesomeicon &&
                                                    <div className="edb-cell">
                                                        <i className={item.awesomeicon + " edb-margin-small-right"}></i>
                                                    </div>}
                                                <span className="adap-text-darkergray edb-margin-small-right">
                                                    {item.title}
                                                </span>
                                            </div>
                                        </th>
                                    )}
                                </tr>
                            </thead>
                            <tbody>
                                {item.pe && item.pe.map((itemb, indexb) =>
                                    <tr key={`table-row-${indexb}`} >
                                        <td className="edb-block-mobile edb-cell-middle">
                                            <span className="adap-text-darkergray edb-margin-small-right">
                                                {itemb.nuPeriod}º período
                                            </span>
                                        </td>

                                        <td className={"edb-block-mobile edb-cell-middle " + (itemb.hasScheduling ? "edb-disabled" : "")}>
                                            <div className="edb-cell edb-block-mobile edb-padding-left">
                                                <div className="adap-input-icon-container ">
                                                    <DatePicker className="adap-input edb-margin-small-bottom"
                                                        selected={itemb.dtStartPeriod}
                                                        onChange={date => this.props.onChangedtStartPeriod(index, indexb, date)}
                                                        onFocus={(e) => (isMobile.any?e.target.readOnly = true:null)}
                                                        startDate={itemb.dtStartPeriod}
                                                        endDate={itemb.dtEndPeriod}
                                                        minDate={this.getStartMinDate(item.pe, indexb)}
                                                        maxDate={this.getStartMaxDate(item.pe, indexb)}
                                                        selectsStart
                                                        dateFormat="dd/MM/yy" />
                                                    <i className="adap-input-icon far fa-calendar-alt"></i>
                                                </div>
                                            </div>
                                            <div className="edb-cell edb-block-mobile edb-padding-left">
                                                <div className="adap-input-icon-container ">
                                                    <DatePicker className="adap-input edb-margin-small-bottom"
                                                        selected={itemb.dtEndPeriod}
                                                        onChange={date => this.props.onChangedtEndPeriod(index, indexb, date)}
                                                        onFocus={(e) => (isMobile.any?e.target.readOnly = true:null)}
                                                        startDate={itemb.dtStartPeriod}
                                                        endDate={itemb.dtEndPeriod}
                                                        minDate={this.getEndMinDate(item.pe, indexb)}
                                                        maxDate={this.getEndMaxDate(item.pe, indexb)}
                                                        selectsEnd
                                                        dateFormat="dd/MM/yy" />
                                                    <i className="adap-input-icon far fa-calendar-alt"></i>
                                                </div>
                                            </div>
                                        </td>

                                        {this.props.editable && <td className={"edb-block-mobile edb-cell-middle " + (itemb.hasScheduling ? "edb-disabled" : "")}>
                                            <div className="edb-cell edb-block-mobile edb-cell-middle">
                                                <div className="edb-btn-link" onClick={ev => this.props.onClickRemoverPeriodo(index, indexb)}>Remover período</div>
                                            </div>
                                        </td>}
                                    </tr>
                                )}
                            </tbody>
                        </table>

                        {this.props.editable && <button className="edb-margin-large-top edb-button edb-gray edb-small edb-round" onClick={ev => this.props.onClickAddPeriodo(index)}>
                            <i className="fas fa-plus edb-margin-small-right"></i>
                            <span>Adicionar período</span>
                        </button>}
                    </div>
                )}


            </div>);
    }
}

export default TabelaPeriodos;